import { TextViewerView } from "./TextViewerView";
import { type TextViewerProps } from "./types";
import { useFileText } from "./useFileText";

export function TextViewer({ fileUrl, fileName }: TextViewerProps) {
  const { text, isLoading, hasLoadError, isTruncated } = useFileText(fileUrl);

  return (
    <TextViewerView
      fileName={fileName}
      isLoading={isLoading}
      hasLoadError={hasLoadError}
      isTruncated={isTruncated}
      text={text ?? ""}
    />
  );
}
